import { render } from "./TextArea.vue?vue&type=template&id=5fe6ac4d"
import script from "./TextArea.vue?vue&type=script&lang=js"
export * from "./TextArea.vue?vue&type=script&lang=js"

import "./TextArea.vue?vue&type=style&index=0&id=5fe6ac4d&lang=scss"

import exportComponent from "/app/tmp/origina/V3/v2026.10.r2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__